import api from './api'

// The consent step of "connect by signing in" (OAuth) for AI tools. The app sends the browser
// to /oauth/consent?request=<handle>; these calls show and answer that request.
export const oauthService = {
  getRequest: async (handle) => {
    const response = await api.get(`/oauth/requests/${encodeURIComponent(handle)}`)
    return response.data
  },

  // → { redirect_to }: where to send the browser (back to the app, with the code)
  approve: async (handle, scopes) => {
    const response = await api.post(`/oauth/requests/${encodeURIComponent(handle)}/approve`, { scopes })
    return response.data
  },

  deny: async (handle) => {
    const response = await api.post(`/oauth/requests/${encodeURIComponent(handle)}/deny`)
    return response.data
  },
}
